/** Phones: the one-column layout with 28px step numbers, 52px tiles and sideways-scrolling frames (the 390px artboards). */
export const REDESIGN_PHONE_MAX_WIDTH = 767;

/** The two columns fit side by side from here: 500px + 580px + the 48px gap + 32px padding on each side. */
export const REDESIGN_TWO_COLUMN_MIN_WIDTH = 1192;

export const isRedesignPhone = (width: number): boolean => width <= REDESIGN_PHONE_MAX_WIDTH;

export const isRedesignTwoColumn = (width: number): boolean => width >= REDESIGN_TWO_COLUMN_MIN_WIDTH;
